import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { UserActions } from '@storeOld/reducers/user/actions'
import { put, select } from 'redux-saga/effects'

import { InternalStorageActions, type StorageActions } from '../actions'

export function* appendAttachments({
  payload,
}: ReturnType<typeof StorageActions.appendAttachments>) {
  const projectId: ID | null = yield select(
    migrationProjectSelector.getProjectId
  )
  const owner: boolean = yield select(
    migrationProjectSelector.getIsCurrentUserOwnerOfProject
  )

  if (!projectId) {
    return
  }

  if (owner) {
    yield put({
      type: UserActions.INCREASE_STORAGE_LIMITS,
      payload,
    })
  }

  const internalActions = InternalStorageActions.appendAttachments(payload)

  yield put(internalActions)
}
